<template>
  <div class="year-main-content">
    <div class="year-top-image" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/' + topImage) + ')' }">
    <div class="year-overlay"><span>2007</span></div>
    </div>
    <div class="view-wrap yr2007">


<FullYearStats fullGames='16' fullCompletions='440' fullAttempts='652' fullYards='4,423' fullPct='67.5' fullTDs='28' fullINTs='18' fullYPG='276.4' fullRating='89.4'></FullYearStats>

  <div class="year-summary-wrapper">
    <div class="triangle-top-left"></div>
    <div class="triangle-bottom-right"></div>
    <div class="year-summary">
    
      <div class="year-summary-text-flex">


      <h1 class="content-headline">A slow start grounds the rising Saints</h1>

      <div class="copy-paragraph">
      The Saints were quickly brought back down to Earth in 2007, following up their most successfull season in franchise history with an 0-4 start.<br/><br/>

      While the Saints offense ranked in the top 5 (Brees ranked 2nd in yards), the defense was in the bottom third of the league and had issues causing turnovers.<br/><br/>

      Drew Brees ended the 2007 season with 4,423 yards, completing 440-of-652 passes and throwing for a career-high 27 touchdowns.<br/><br/>

      The Saints would win 7 of their last 12 games but it wasn't enough to overcome their slow start.<br/><br/>
      </div>

      <div class="copy-paragraph">
      <img :src="require('@/assets/brees-2007-img-in-copy.jpg')" style="width:100%;" alt="Drew Brees and Donovan McNabb shake hands postgame">
      </div>

      <div class="awards-wrapper">
        <div class="awards-headline">2007 Awards</div>
        <ul>
          
          <li><img :src="require('@/assets/pfwa-award.jpg')" alt="Pro Football Writers of America Logo"> PFWA George Halas Award</li>
          <li><img :src="require('@/assets/pfwa-award.jpg')" alt="Pro Football Writers of America Logo"> PFWA Arthur S. Arkush Humanitarian Award</li>
        </ul>
      </div> 


      </div> <!--end text-flex-->
    </div>
  </div>


   <div class="bubble-chart-wrapper chart-light">
      <h2 class="chart-headline">2007 Top Rated Passers</h2>
      <BubbleChart :chart-data="dataBubble1" :options="dataOptions3" style="height:400px;"></BubbleChart>
    </div>



<div class="touchdowns-header-wrapper">
  <h1><img src="https://nolaprodigital.com/saints/brees500/images/referee-icon-white.png" alt="Drew Brees 2007 Touchdown Tally"> 2007 TOUCHDOWN TALLY</h1>
</div>


</div>


<TDsByYear :tds="this.tds"></TDsByYear>



<flickity ref="flickity" :options="flickityOptions">
  <div class="carousel-cell"><img :src="require('@/assets/' + image1)" alt="Drew Brees in 2007 - Slide1"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image2)" alt="Drew Brees in 2007 - Slide2"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image3)" alt="Drew Brees in 2007 - Slide3"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image4)" alt="Drew Brees in 2007 - Slide4"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image5)" alt="Drew Brees in 2007 - Slide5"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image6)" alt="Drew Brees in 2007 - Slide6"></div>
</flickity>


<div class="year-pagination-wrapper">
  <div class="year-pagination-section year-pagination-prev"><router-link to="/year/2006">«2006</router-link></div>
  <div class="year-pagination-section year-pagination-current">2007</div>
  <div class="year-pagination-section year-pagination-next"><router-link to="/year/2008">2008»</router-link></div>
</div>



    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import StatsFlex from '@/components/StatsFlex.vue'
import Flickity from 'vue-flickity';
import VideoBtn from '@/components/VideoBtn.vue';
import FullYearStats from '@/components/FullYearStats.vue';
import TDsByYear from '@/components/TDsByYear.vue';
import BubbleChart from '@/components/BubbleChart.vue'

import axios from 'axios';

export default {
  name: 'yr2007',
  components: {
    Flickity,
    StatsFlex,
    VideoBtn,
    FullYearStats,
    TDsByYear,
    BubbleChart
  },
  metaInfo: {
    title: 'Drew Brees Stats and Touchdowns from his 2007 season',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      tds: {},
      loading: false,
      games: [],
      topImage: "brees-2007-top.jpg",
      image1: "brees-2007-slide-1.jpg",
      image2: "brees-2007-slide-2.jpg",
      image3: "brees-2007-slide-3.jpg",
      image4: "brees-2007-slide-4.jpg",
      image5: "brees-2007-slide-5.jpg",
      image6: "brees-2007-slide-6.jpg",

      flickityOptions: {
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: false,
            resize: true,
            wrapAround: true,
            autoPlay: true

            // any options from Flickity can be used
            }

          } 
        },
  methods: {
    async getTDs() {
      const self = this;
      const response = await axios.get(
        "../../static/td-data.json"
      );
      this.tds = response.data.y2007;
      console.log(this.tds)
    },
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },
    resize() {
      this.$refs.flickity.resize();
    }
  },

   mounted: function() {
    this.getTDs();

    setTimeout(() => {
    this.$refs.flickity.resize();
    }, 2000)

},
created() {

      

       this.dataBubble1 = {
      "datasets": [
      {
        "label": "Drew Brees",
        "backgroundColor": "#101820",
        "borderColor": "#D3BC8D",
        "fill": false,
        "pointBackgroundColor": '#D3BC8D',
        "pointColor": "#D3BC8D",
        
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#D3BC8D",
        data: [
                {
                  x: 67.5,
                  y: 4423,
                  r: 28/1.5
                }
              ]
      },
      {
        "label": "Peyton Manning",
        "backgroundColor": "#fff",
        "borderColor": "#002C5F",
        "fill": false,
        radius: 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 65.4,
                  y: 4040,
                  r: 31/1.5
                }
              ]
      },
      {
        "label": "Tom Brady",
        "backgroundColor": "#002244",
        "borderColor": "#C60C30",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 68.9,
                  y: 4806,
                  r: 50/1.5
                }
              ]
      },
      {
        "label": "Ben Roethlisberger",
        "backgroundColor": "#FFB612",
        "borderColor": "#101820",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 65.3,
                  y: 3154,
                  r: 32/1.5
                }
              ]
      },
      {
        "label": "Brett Favre",
        "backgroundColor": "#203731",
        "borderColor": "#FFB612",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 66.5,
                  y: 4155,
                  r: 28/1.5
                }
              ]
      }
      ]
    },
    this.dataOptions3 = {
        "responsive": true,
        "maintainAspectRatio": false,
        title: {
            display: true,
            text: '(Bubble size is Touchdowns)'
        },
        "layout": {
          padding: {
                left: 10,
                right: 10,
                top: 0,
                bottom: 0
          },
        },
        "legend": {
          "position" : "bottom",
            "maxSize" : {
                "height" : 400
            },
            "labels": {
                "fontColor": "black",
                "fontSize": 14,
                "usePointStyle" : true
            }
        },
        tooltips: {
          "mode": "point",
          callbacks: {
              label: function(tooltipItem, data) {
                 var rLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].r;
                  var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                  return datasetLabel + ' : ' + tooltipItem.yLabel.toLocaleString() + ' Yards, ' + tooltipItem.xLabel.toLocaleString() + ' Completion %, ' + rLabel*1.5 + ' TDs';
              }
          }
        },
        "scales": {
          "yAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Yards'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
                },
            "ticks": {
              "fontColor": 'black',
              callback: function(value, index, values) {
                        return value.toLocaleString();
                    },
            },
          }],
          "xAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Completion Percentage'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
            },
            "ticks": {
              
              "fontColor": 'black'
            },
          }]
        }
    }

    }
}
</script>

<style>

.year-top-image > img {
  width:100%;
}


@media (max-width:767px;) {
  .year-main-content {
  margin-top:35px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/yr2007.vue